import React from "react";
import cx from "classnames";


export default class DomainButton extends React.Component {
  state = {};

  onClick = () => {
    let clicked = !this.state.clicked;
    this.props.onClick(clicked);
    this.setState({ clicked })
  }

  render() {
    const { clicked } = this.state;
    return (
      <button onClick={this.onClick} className={cx({clicked},"closed-menu")}>
        <div className="title"><h3>Domain of the Day</h3></div>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DomainButton.js